module.exports = __webpack_public_path__ + "static/media/article5.0ee3cc92.webp";